const elements = document.querySelectorAll('[data-animate]');

if (elements.length) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.08, rootMargin: '0px 0px -40px 0px' },
  );

  elements.forEach((el) => {
    const { top, bottom } = el.getBoundingClientRect();
    if (top < window.innerHeight && bottom > 0) {
      requestAnimationFrame(() => el.classList.add('is-visible'));
    } else {
      observer.observe(el);
    }
  });
}
